import script from "./Consensi.vue?vue&type=script&setup=true&lang=ts"
export * from "./Consensi.vue?vue&type=script&setup=true&lang=ts"

import "./Consensi.vue?vue&type=style&index=0&id=03e9e35d&lang=css"

const __exports__ = script;

export default __exports__